import { useEditorStore } from "@/zapi-frontend/stores/editor";
import { useCallback, useEffect } from "react";
import { isTableRow, stripMarkdown } from "./stripMarkdown";
import { useMediaQuery } from "@/zapi-frontend/shared/hooks/useMediaQuery";

export function useHighlightClaim({ claimMarkdown }: { claimMarkdown: string | undefined }) {
  const { highlightText, highlightTableRow } = useEditorStore();

  const isMobile = useMediaQuery("(max-width: 984px)");

  const focusClaim = useCallback(() => {
    if (isMobile) return;

    if (claimMarkdown) {
      const isTable = isTableRow(claimMarkdown);

      if (isTable && highlightTableRow) {
        const cleanText = stripMarkdown(claimMarkdown);
        highlightTableRow(claimMarkdown, cleanText);
      } else if (highlightText) {
        const cleanText = stripMarkdown(claimMarkdown);
        highlightText(cleanText);
      }
    }
  }, [claimMarkdown]);

  useEffect(() => {
    focusClaim();
  }, [claimMarkdown]);

  return { focusClaim };
}
